const wwConstants ={
    //客户端本地存储Key
    localStorage: {
        username: "username",
        organizationId: "organizationId",
        userType: "userType",
        //是否是车牌号/IMEI登录
        isLicenseNumberOrImeiLogin: "isLicenseNumberOrImeiLogin",
        isOldLogin: "isOldLogin",
        rememberMe: "goome_gps_rememberMe",
        rememberMeIMEI: "goome_gps_rememberMeIMEI",
        deviceSaleTransfer: 'deviceSaleTransfer',
        deviceInfo: 'deviceInfo',
        instruction: 'instruction',
        loginCode: 'loginCode',
        alarmVoiceAlert: 'alarmVoiceAlert',
        warningType: 'WarningType'
    },
    regExp : {
        phoneNumber:/^1[3|4|5|7|8][0-9]{9}$/,
        number:/^[0-9]*$/,
        licenseNumber:/^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/
    },
    maxLengthMap:{
        "vehicle":"32"
    },
    //时间格式
    timeSet:{
        "dateFormat" :"YYYY-MM-DD HH:mm:ss",
        "dateFormatWithOutHMS" : "YYYY-MM-DD"
    },
    //设备终端字段
    vinInfoParams:[
        {title:Strings.carCode1 || "机械编号：",key:"carCode",required:true},
        {title:Strings.carName || "车辆名称：",key:"carName"},
        {title:Strings.carType1 || "车辆类型：",key:"carModelId",required:true},
        {title:Strings.vin || "车架号：",key:"vin"},
        {title:Strings.engineCode || "发动机编号：",key:"engineCode"},
        {title:Strings.factoryTime || "出厂日期：",key:"factoryTime",type:"day",format:"YYYY-MM-DD"},
        {title:Strings.maintenanceTime || "维保时间：",key:"maintenanceTime",type:"day",format:"YYYY-MM-DD"},
        {title:Strings.driverName || "驾驶员：",key:"driverName"},
        {title:Strings.driverPhone || "驾驶员电话：",key:"driverPhone"},
        {title:Strings.installTime || "安装时间：",key:"installTime",type:"day",format:"YYYY-MM-DD"},
        {title:Strings.installUser || "安装人员：",key:"installUser"},
        {title:Strings.carRemark || "车辆备注：",key:"remark"},
    ],
    deviceInfoParams:[
        {title:Strings.imei1 || "设备号：",key:"imei",disabled:true},
        {title:Strings.deviceType1 || "设备型号：",key:"deviceType",disabled:true},
        {title:Strings.deviceStatusName || "设备状态：",key:"deviceStatusName",disabled:true},
        {title:Strings.workStatusName || "工作状态：",key:"workStatusName",disabled:true},
        {title:Strings.serviceStartTime1 || "服务开始时间：",key:"serviceStartTime",type:"day",disabled:true},
        {title:Strings.serviceEndTime1 || "服务结束时间：",key:"serviceEndTime",type:"day",disabled:true},
        {title:Strings.periodName || "年期：",key:"periodName",disabled:true},
        {title:Strings.saleTime1 || "导入时间：",key:"saleTime",type:"time",disabled:true},
        {title:Strings.firstPositionTime1 || "首次定位时间：",key:"firstPositionTime",type: "time",disabled:true},
        {title:Strings.firstPosition1 || "首次定位位置：",key:"firstPosition",disabled:true},//todo
        {title:Strings.gpsTime1 || "最后定位时间：",key:"gpsTime",type:"time",disabled:true},
        {title:Strings.position1 || "最后位置：",key:"position",disabled:true},//todo
        {title:Strings.cmdLockStatusName || "当前锁车信息：",key:"cmdLockStatusName",disabled:true},
        {title:Strings.latestActiveTime || "最后信号时间：",key:"latestActiveTime",type:"time",disabled:true},
        {title:Strings.sim1 || "SIM卡号：",key:"sim",},
        {title:Strings.devRemark || "备注：",key:"remark"}
    ],
    workStParams:[
        {key:"onSeconds",icon:"default iconfont icon-gongzuoshichang green"},
        {key:"offSeconds",icon:"default iconfont icon-gongzuoshichang gray"},
        {key:"onTimes",icon:"default iconfont icon-gongzuozongcishu orange"},
        {key:"offTimes",icon:"default iconfont icon-gongzuozongcishu gray"},
        {key:"avgOnSeconds",icon:"default iconfont icon-gongzuoshichang purple"},

    ],
    orgConfig:{
        "userconfig_1":"200",
        "userconfig_2":"202",
        "userconfig_3":"201",
        "userconfig_4":"203",
    },
    AlarmPage: {
        main: 1,//在主页
        position: 2//在监控页面
    },
    mapType_coordinate:[
        {key:"baidu",coordinate:"bd09ll",value:1},
        {key:"google",coordinate:"wgs84ll",value:0},
        {key:"gaode",coordinate:"gcj02ll",value:0},
    ],
    MapPosition : {
        TOPLEFT: 'topleft',
        TOPRIGHT: 'topright',
        BOTTOMLEFT: 'bottomleft',
        BOTTOMRIGHT: 'bottomright'
    }
}
export  default wwConstants